<template>
  <div class="manage-plant">
    <div class="row">
      <div class="col-3">
        <div class="row">
          <div class="col-12 row-header">Customer</div>
        </div>
        <div class="scrolling-table" v-show="!loading">
          <template v-for="item in plants">
            <div
              class="row clickable"
              :key="item.id"
              v-show="item.active == !show_deleted && item.site_id == site_id"
              v-bind:class="{ selected: item == plant }"
              @click="_plantSelected(item)"
            >
              <div class="col-12">
                {{ item.name }}
              </div>
            </div>
          </template>
        </div>
      </div>
      <div class="col-9">
        <div class="row">
          <PlantDetail
            :plant="plant"
            class="col-12"
            ref="plant_detail"
            @new="_new"
          />
          <NewPlantModal
            ref="new_plant_modal"
            v-show="showNewPlantModal"
            @close="_closeNewPlantModal"
            :site_id="site_id"
          />
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-3">
        <input type="checkbox" id="show_deleted" @click="_show_deleted" />
        <label for="show_deleted">Show Deleted</label>
      </div>
    </div>
  </div>
</template>

<script>
import PlantDetail from "@/components/admin/plant/PlantDetail.vue";
import NewPlantModal from "@/components/admin/plant/NewPlantModal.vue";
import { mapState, mapActions } from "vuex";

export default {
  name: "Plants",
  props: {
    site_id: {
      type: Number,
      required: true,
    },
  },
  data: () => ({
    plant: null,
    loading: false,
    show_deleted: false,
    showNewPlantModal: false,
  }),
  computed: {
    ...mapState("plants", ["plants", "new_plant"]),
    ...mapState("sites", ["new_site"]),
  },
  watch: {
    site_id() {
      this.plant = null;
      this.$refs.plant_detail.clear();
      this.$refs.new_plant_modal.clear();
    },
    new_plant(new_value) {
      this.plant = new_value;
      this.$refs.new_plant_modal.clear();
    },
  },
  methods: {
    ...mapActions("plants", ["apiSavePlant", "apiCreatePlant"]),
    _show_deleted() {
      this.show_deleted = !this.show_deleted;
    },
    _save() {
      this.$refs.plant_detail.save();
    },
    _new() {
      this.showNewPlantModal = true;
    },
    _closeNewPlantModal() {
      this.showNewPlantModal = false;
    },
    _showTab(index) {
      this.tab = index;
    },
    _plantSelected(plant) {
      this.plant = plant;
    },
    _delete() {
      if (this.plant != null && this.plant.id > 0) {
        this.plant.active = !this.plant.active;
        this.apiSavePlant(this.plant);
      }
    },
  },
  components: {
    PlantDetail,
    NewPlantModal,
  },
};
</script>
